var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddOrganisation = function SvgAddOrganisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.19 19.5"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".add-organisation_svg__addo{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-organisation_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-organisation_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.24 17.47v.22A1.31 1.31 0 0 1 18.93 19h-.01l-17.11-.12A1.33 1.33 0 0 1 .5 17.55L.58 5.71A1.33 1.33 0 0 1 1.91 4.4h0L19 4.52a1.31 1.31 0 0 1 1.31 1.31v.01h0v5.22M4.51 9l11.84.08M4.47 14.29l11.85.08M13.41 1.43a1.31 1.31 0 0 0-1.24-.91L8.8.5a1.31 1.31 0 0 0-1.25.89l-1 3 7.9.06ZM3.22 4.41V3.09M17.7 4.51V3.19M25.44 18.68a4.25 4.25 0 1 0-4.25-4.25 4.25 4.25 0 0 0 4.25 4.25M25.44 12.31v4.25M27.56 14.43h-4.25",
    className: "add-organisation_svg__addo"
  })))));
};
export default SvgAddOrganisation;